import { render, staticRenderFns } from "./askAiUiModal.vue?vue&type=template&id=607a78e6&scoped=true"
import script from "./askAiUiModal.vue?vue&type=script&lang=js"
export * from "./askAiUiModal.vue?vue&type=script&lang=js"
import style0 from "./askAiUiModal.vue?vue&type=style&index=0&id=607a78e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "607a78e6",
  null
  
)

export default component.exports